import { VITE_API_URL } from './utils';

export function getApiUrl(): string {
  return VITE_API_URL;
}
